import crvLogo from 'libs/tokens/img/crv.svg';
import crvUsdLogo from 'libs/tokens/img/crvUsd.svg';
import ethLogo from 'libs/tokens/img/eth.svg';
import usdcLogo from 'libs/tokens/img/usdc.svg';
import usdtLogo from 'libs/tokens/img/usdt.svg';
import wbtcLogo from 'libs/tokens/img/wbtc.svg';
import wethLogo from 'libs/tokens/img/weth.svg';
import wstEthLogo from 'libs/tokens/img/wstEth.svg';
import MNTLogo from 'libs/tokens/img/mnt.svg';
// import xvsLogo from 'libs/tokens/img/krai.svg';
import kreiLogo from 'libs/tokens/img/krei.svg'
import type { Token } from 'types';
import PHRLogo from 'libs/tokens/img/phr.svg';

const phrToken: Token = {
  address: '0x0000000000000000000000000000000000000000',
  decimals: 18,
  symbol: 'PHR',
  asset: PHRLogo,
  isNative: true,
};

export const tokens: Token[] = [
  phrToken,
  {
    address: '0x42FC710ff3135BE9594357Fdd5a6a9F9a8Bc3189',
    decimals: 18,
    symbol: 'KRAI',
    asset: kreiLogo,
  },
  {
    address: '0xeC89670b3D41b07F14A882b4af032E0442db6334',
    decimals: 18,
    symbol: 'WPHR',
    asset: PHRLogo,
  },
  {
    address: '0xa896eB4C16E12312c5aDf45FcdE547eE2e8cB542',
    decimals: 18,
    symbol: 'WETH',
    asset: wethLogo,
  },
  {
    address: '0x77Bb04Fc2e34116A0cf75667BfbF32Aaa6b858fD',
    decimals: 6,
    symbol: 'USDC',
    asset: usdcLogo,
  },
];
